/**
 * @ngdoc service
 * @name common.service:wishlistServiceApi
 * @description
 * description
 */
(function() {

    'use strict';

    angular
        .module('itxApp.wishlist')
        .service('WishlistServiceApi', wishlistServiceApi);

    wishlistServiceApi.$inject = [
        '$q',
        'ItxErrorMessagesFct',
        'ItxTranslateSvc'
    ];

    function wishlistServiceApi(
        $q,
        ItxErrorMessagesFct,
        ItxTranslateSvc
    ) {
        
        var _this = this;

        _this.ItemWishlist = function (item, wishEnabled) {
            var catentryId = item.sku;
            if (wishEnabled) {
                // we take first size's sku for the new wishlist
                var found = _.find(item.colors, function (itemColor) {
                    return itemColor.id === item.colorId;
                });
                var catentryId = found.sizes[0].sku;
            }
            var id = item.parentId;
            if (item.activeDetail) {
                id = item.id;
            }
            return {
                catentryId: catentryId,
                productId: id,
                quantity: item.quantity
            };
        };

        var service = {
            getWishlist: getWishlist,
            deleteWishlist: deleteWishlist,
            addItemWishlist: addItemWishlist,
            deleteItemWishlist: deleteItemWishlist
        };

        return service;

        /*
         *  @param name = String
         */
        function getWishlist(name) {
            var deferred = $q.defer();
            inditex.wishlist.list( function(status, response) {
                
                if(status == 1 && response && response.wlArray && response.wlArray.length > 0) {
                    var foundList = false; 
                    
                    _.each(response.wlArray, function (list, index) {
                        if(list.name === name) {
                            foundList = true;
                            inditex.wishlist.getByIndex(index, function(status, data) {
                                if(status == 1 && data) {
                                    deferred.resolve(data);
                                } else {
                                    deferred.reject('No tenemos niguna wishlist activa para este usuario');
                                }            
                            });
                        }
                    });
                    if(!foundList){
                        deferred.reject('No tenemos niguna wishlist con este nombre para este usuario');
                    }
                } else {
                    deferred.reject('No tenemos niguna wishlist activa para este usuario');
                }  
            });
            return deferred.promise;
        }

        /*
         *  @param name = String
         */
        function deleteWishlist(name) {
            var deferred = $q.defer();
            // inditex.wishlist.removeWishlist(0, function(status, response) {console.log("status:" + status);console.log("response:" + response);});
            // response {"type":"wish","brand":"ZH","wlArray":[]}
            inditex.wishlist.removeWishlist(name, function(status) {
                if (status === 1) {
                    deferred.resolve(inditex.wishlist);
                } else {
                    deferred.reject();
                }
            });
            return deferred.promise;
        }

        /*
         *  @param name = String
         *  @param item = Object any
         */
        function addItemWishlist(name, item, wishEnabled) {
            return _updateWishlist(name, item, wishEnabled);
        }

        /*
         *  @param name = String
         *  @param item = Object any
         */
        function deleteItemWishlist(name, item) {
            //item.quantity = -10;
            var deferred = $q.defer();
            var newItem =  _this.ItemWishlist(item);
            inditex.wishlist.list( function(status, response) {
                
                if(status == 1 && response && response.wlArray && response.wlArray.length > 0) {
                    var foundList = false; 

                    _.each(response.wlArray, function (list, index) {
                        if(list.name === name) {
                            foundList = true;

                            inditex.wishlist.remove(index, newItem.catentryId, function(status, data) {
                                if (status == 1) {
                                    deferred.resolve(data);
                                } else {
                                    deferred.reject();
                                }
                            });
                        }
                    });
                    if(!foundList){
                        deferred.reject('No tenemos niguna wishlist con este nombre para este usuario');
                    }
                } else {
                    deferred.reject('No tenemos niguna wishlist activa para este usuario');
                }  
            });
            return deferred.promise;
        }
        
        /*
         * PRIVATE FUNCTIONS
         */
        function _updateWishlist(name, item, wishEnabled) {
            var deferred = $q.defer();
            inditex.wishlist.create(name, _this.ItemWishlist(item, wishEnabled), function(status, data) {
                if (status == 1) {
                    deferred.resolve(data);
                } else {
                    if(data && data.httpStatus == 413 || data && data.error && data.error && data.error.error == '413'){
                        // Max items wishlist
                        ItxErrorMessagesFct.dialog( ItxTranslateSvc.translateCms('legacy.common.wishlist.maxSizeItems') );
                    }
                    deferred.reject();
                }
            }, null);
            return deferred.promise;
        }

    }

})();